/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ObjectKeywords from './objects/ObjectKeywords.js';
import EnrollContent from './EnrollContent.js';
import GenerateSecureWeblink from '../widgets/GenerateSecureWeblink.js'
import ObjectSharing from './objects/ObjectSharing.js';
import ChatInterface from '../widgets/ChatInterface.js'
import ImageSearch from '../widgets/ImageSearch.js'

class VaultViewModal extends React.Component
{
  closing = false;
  modalTitle = null;
  refreshVaultViewTabOnClose = false;
  elementRef = React.createRef();

  constructor(props)
  {
    super();
    
    this.toggleModal = this.toggleModal.bind(this);
    this.refreshVaultViewTab = this.refreshVaultViewTab.bind(this);
  }

  refreshVaultViewTab()
  {
    this.refreshVaultViewTabOnClose = true;
  }

  render()
  {
    if (this.props.vaultViewModalIsOpen) this.closing = false;
    let className = 'modal-lg';

    switch (this.props.component)
    {
      case ('keywords'):
        this.modalTitle = 'Object Keywords';
        break;

      case ('enroll'):
        this.modalTitle = 'Enroll Content';
        className = 'modal-md';
        break;

      case ('secure weblink'):
        this.modalTitle = 'Generate A Secure Weblink';
        className = 'modal-md';
        break;

      case ('sharing'):
        this.modalTitle = 'Object Sharing';
        break;

      case ('chatInterface'):
        this.modalTitle = 'AI Chatbot Interface';
        className = 'modal-md';
        break;

      case ('imageSearch'):
        this.modalTitle = 'MultiModal Search';
        className = 'modal-md';
        break;

      default:
        break;
    }

    return(
      <Modal className={className} isOpen={this.props.vaultViewModalIsOpen} toggle={this.toggleModal} autoFocus={false} >
        <ModalHeader toggle={this.toggleModal}>{this.modalTitle}</ModalHeader>
        <ModalBody>
          {this.renderComponent(className)}
        </ModalBody>
        <ModalFooter>
          <Button className="float-right" color="secondary" onClick={this.toggleModal}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  renderComponent(className)
  {
    let objectNamesString = null;

    if (this.props.selectedObjects.length)
    {
      objectNamesString = '';
      var objectNames = this.props.selectedObjects[0].objectName;
      for (let x = 1; x < 9 && x < this.props.selectedObjects.length; x++)
      {
        objectNames += ', ' + this.props.selectedObjects[x].objectName;
      }
  
      if (9 < this.props.selectedObjects.length) objectNames += '...';
  
      objectNamesString += objectNames;
    }

    switch (this.props.component)
    {
      case ('keywords'):
        return (
          <div>
            {objectNamesString}
            <ObjectKeywords refreshVaultViewTab={this.refreshVaultViewTab} selectedObjects={this.props.selectedObjects} 
              viewType={this.props.viewType} refreshQueryValues={this.props.refreshQueryValues}
            />
          </div>
        );

      case ('enroll'):
        return (
          <EnrollContent  />
        );

      case ('secure weblink'):
        return (
          <div>
            {objectNamesString}
            <GenerateSecureWeblink selectedObject={this.props.selectedObjects[0]} modalSize={className} />
          </div>
        );       

      case ('sharing'):
        return (
          <div>
            {objectNamesString}
            <ObjectSharing selectedObjects={this.props.selectedObjects} ref={this.elementRef} toggleModal={this.toggleModal}
              refreshVaultViewTab={this.refreshVaultViewTab}
            />
          </div>
        );

      case ('chatInterface'):
        return(
          <div>
            <ChatInterface objectNames={objectNamesString} selectedObjects={this.props.selectedObjects} viewType={this.props.viewType}
              objectTypePickerData={this.props.objectTypePickerData} filterData={this.props.filterData} matchAnyOrAll={this.props.matchAnyOrAll} />
          </div>          
        );

      case ('imageSearch'):
        return (
          <div>
            <ImageSearch objectNames={objectNamesString} selectedObjects={this.props.selectedObjects} viewType={this.props.viewType}
              objectTypePickerData={this.props.objectTypePickerData} filterData={this.props.filterData} matchAnyOrAll={this.props.matchAnyOrAll} />
          </div>          
        );
      default:
        break;
    }
  }

  toggleModal(event)
  {
    if (this.closing) return;

    if (null !== this.elementRef.current && !this.elementRef.current.canModalClose()) return;

    this.closing = true;
    this.props.onClose();
    if (this.refreshVaultViewTabOnClose) this.props.refreshVaultViewTab();
    this.refreshVaultViewTabOnClose = false;
  }
}

export default VaultViewModal